/**
 * Shared chrome for the auth page's secondary actions.
 *
 * Lives apart from `auth-styles.ts` on purpose. That module carries six
 * pre-existing `pp/no-arbitrary-font-size` warnings on Figma-derived type-scale
 * values (`text-[15px]`, `text-[22px]`, ...), and the repo gates a touched file
 * at zero warnings. Clearing them means moving every auth page onto the scale
 * tokens - 15px to 14px, 22px to 20px - which is a design call, not a passkey
 * change. Adding a constant there would have forced that call as a side effect
 * of shipping a button, so the constant sits here and `auth-styles.ts` is left
 * exactly as it was for whoever makes the type-scale decision properly.
 */

/**
 * Full-width secondary auth action, shared by the social sign-in buttons and the
 * passkey affordance. Deliberately NOT `AUTH_BUTTON_CLASS`: that is the page's
 * primary CTA, and a second solid brand button competes with "Sign in".
 */
export const AUTH_SECONDARY_BUTTON_CLASS =
  'flex h-11 w-full cursor-pointer items-center justify-center gap-3 rounded-xl border border-secondary bg-surface px-4 transition-colors hover:bg-surface-secondary focus-visible:ring-2 focus-visible:ring-[var(--color-brand-solid)]/40 focus-visible:ring-offset-1 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 dark:hover:bg-[var(--color-bg-quaternary)] dark:focus-visible:ring-[var(--color-brand-solid)]/60 dark:focus-visible:ring-offset-0';

export const AUTH_TILE_BUTTON_CLASS =
  'flex min-h-20 w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border border-secondary bg-surface px-3 py-3 text-xs font-medium text-secondary transition-colors hover:border-brand hover:bg-brand-secondary focus-visible:ring-2 focus-visible:ring-[var(--color-border-brand)]/40 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50';
